import { createPersistentEmitter } from 'src/lib/Emitter';

export type Handler = (opts: any) => void;
export type Handlers = { [id: string]: Handler[] };

class PopupMonitor {
  private openPopups: { [key: string]: boolean } = {};
  private onOpenHandlers: Handlers = {};
  private onCloseHandlers: Handlers = {};

  init() {
    createPersistentEmitter((state) => state.ui.togglePopup).addListener(
      (command) => {
        if (command.enabled === this.openPopups[command.id]) {
          return;
        }

        this.openPopups[command.id] = command.enabled;

        const handlers = command.enabled
          ? this.onOpenHandlers
          : this.onCloseHandlers;
        this.callHandlers(handlers, command.id, command.opts);
      },
    );
  }

  isOpen(id: string) {
    return !!this.openPopups[id];
  }

  getOpenPopups() {
    return Object.keys(this.openPopups).filter((id) => this.isOpen(id));
  }

  addOnOpenHandler(id: string, handler: Handler) {
    return this.addHandler(this.onOpenHandlers, id, handler);
  }

  removeOnOpenHandler(id: string, handler: Handler) {
    return this.removeHandler(this.onOpenHandlers, id, handler);
  }

  addOnCloseHandler(id: string, handler: Handler) {
    return this.addHandler(this.onCloseHandlers, id, handler);
  }

  removeOnCloseHandler(id: string, handler: Handler) {
    return this.removeHandler(this.onCloseHandlers, id, handler);
  }

  //

  private addHandler(handlers: Handlers, id: string, handler: Handler) {
    if (!handlers[id]) {
      handlers[id] = [];
    }

    handlers[id].push(handler);

    return handler;
  }

  private removeHandler(handlers: Handlers, id: string, handler: Handler) {
    const index = handlers[id].indexOf(handler);
    if (index < 0) {
      throw new Error('Handler not found.');
    }

    handlers[id].splice(index, 1);
  }

  private callHandlers(handlers: Handlers, id: string, opts: any) {
    if (!handlers[id]) {
      return;
    }

    handlers[id].forEach((handler) => handler(opts));
  }
}

export default new PopupMonitor();
